/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { InfoCircleIcon16Light } from './InfoCircleIcon16Light';
import { InfoCircleIcon16Regular } from './InfoCircleIcon16Regular';
import { InfoCircleIcon16Solid } from './InfoCircleIcon16Solid';
import { InfoCircleIcon20Light } from './InfoCircleIcon20Light';
import { InfoCircleIcon20Regular } from './InfoCircleIcon20Regular';
import { InfoCircleIcon20Solid } from './InfoCircleIcon20Solid';
import { InfoCircleIcon24Regular } from './InfoCircleIcon24Regular';
import { InfoCircleIcon24Solid } from './InfoCircleIcon24Solid';
import { InfoCircleIcon32Regular } from './InfoCircleIcon32Regular';
import { InfoCircleIcon64Regular } from './InfoCircleIcon64Regular';
var sizes = {
    16: {
        light: InfoCircleIcon16Light,
        regular: InfoCircleIcon16Regular,
        solid: InfoCircleIcon16Solid,
    },
    20: {
        light: InfoCircleIcon20Light,
        regular: InfoCircleIcon20Regular,
        solid: InfoCircleIcon20Solid,
    },
    24: {
        regular: InfoCircleIcon24Regular,
        solid: InfoCircleIcon24Solid,
    },
    32: {
        regular: InfoCircleIcon32Regular,
    },
    64: {
        regular: InfoCircleIcon64Regular,
    },
};
export var InfoCircleIcon = forwardRef('InfoCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
